import { render, staticRenderFns } from "./OrderDetailsView.vue?vue&type=template&id=572876a5&"
import script from "./OrderDetailsView.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports